import React, { Component } from 'react';
import { connect } from 'react-redux';
import HeaderDetails from 'eymp-uicomps/components/HeaderDetails';
import { Grid } from '@material-ui/core';
import CloseIcon from '../../../assets/dashboardIcons/CloseIcon.png';
import { Button } from 'eymp-uicomps';
import { fnGetCaseRelatedId, fnSetIsAllCaseToggle } from 'src/helpers/commonFunctions';
import { getDashboardCaseDetails } from 'src/services/cases.service';
import { formatDate } from 'src/helpers/date';
import { NEW_DASHBOARD_URL } from 'src/constants/constants';
import intl from 'react-intl-universal';
import { setCaseDataHeader } from 'src/new-ui/features/CaseDataCollect/state/caseDataCollectAction';
class CaseDataEmployeeHeader extends Component {
  componentDidMount() {
    this.getDashBoardDetails();
  }

  getDashBoardDetails = () => {
    let caseId = fnGetCaseRelatedId(2);
    if (!caseId) {
      return;
    }
    return getDashboardCaseDetails(caseId).then(resp => {
      this.props.setCaseDataHeader(resp);
    });
  };
  handleOnClick = () => {
    fnSetIsAllCaseToggle(false);
    sessionStorage.removeItem('case_nav');
    window.location.href = NEW_DASHBOARD_URL;
  };

  render() {
    const { casedetails } = this.props;
    if (!casedetails) return;
    const details = [
      {
        component: (
          <div>
            <Grid container className="align-items-center align-items-unset">
              <Grid item sm={6}>
                {casedetails && (
                  <div className="emp-header">
                    <div className="font-bold font-18">{casedetails.employeeName}</div>
                    <div className="font-light font-12">
                      <span>{casedetails.serviceName ? casedetails.serviceName : ''} </span>
                      <span>{casedetails.serviceName && casedetails.serviceCountry && ' | '}</span>
                      <span>{casedetails.serviceCountry ? casedetails.serviceCountry : ''} </span>
                      <span>{casedetails.serviceCountry && casedetails.caseTicketId && ' | '}</span>
                      <span>{casedetails.caseTicketId ? casedetails.caseTicketId : ''} </span>
                      <span>{casedetails.caseTicketId && casedetails.travelStartDate && casedetails.travelEndDate && ' | '}</span>
                      <span>
                        {casedetails.travelStartDate && casedetails.travelEndDate
                          ? ` ${intl.get('newDashboard.detailsCard.travelDates')}: ` +
                            formatDate(casedetails.travelStartDate) +
                            ` ${intl.get('newDashboard.detailsCard.to')} ` +
                            formatDate(casedetails.travelEndDate)
                          : ''}
                      </span>
                    </div>
                  </div>
                )}
              </Grid>
              <Grid item sm={6}>
                <div className="text-align-end close-button">
                  <Button onClick={() => this.handleOnClick()}>
                    CLOSE <img src={CloseIcon} alt="Close" />
                  </Button>
                </div>
              </Grid>
            </Grid>
          </div>
        ),
      },
    ];
    return (
      <div className="emp-header-detail">
        <HeaderDetails details={details} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    casedetails: state.caseDatacollectMenu.caseHeaderDetails,
  };
};

const mapDispatchToProps = {
  setCaseDataHeader,
};
export default connect(mapStateToProps, mapDispatchToProps)(CaseDataEmployeeHeader);
